import { inject } from '@angular/core';
import { HttpRequest, HttpHandlerFn, HttpEvent, HttpInterceptorFn, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { AuthService } from '@share';
import { catchError, Observable, of, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';

export const AuthInterceptor: HttpInterceptorFn = (req: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> => {
  const authService = inject(AuthService);
  const messageService=inject(NzMessageService);
  const router = inject(Router);
  const token = authService.getToken();

  // if (req.url.includes('mock')) {
  //   const mockData = [
  //     { value: 'test', text: 'Mock Item 1' },
  //     { value: 'test2', text: 'Mock Item 3' },
  //   ];
  //   return of(new HttpResponse({ status: 200, body: mockData }));
  // }

  // If token exists, clone the request and add the Authorization header
  const clonedReq = token ? req.clone({
    setHeaders: {
      Authorization: `Bearer ${token}`,
    },
  }) : req;

  return next(clonedReq).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        // Clear stored token and redirect to login page
        authService.logout();
        router.navigate(['/auth/login']);
      } 
       return throwError(() => error);
    })
  );
};
